import { FC, useEffect, useMemo } from 'react';
import {
  AudioType,
  getAppAudio,
  IconChatSidebar,
  IconSettingsSidebar,
  IconStatsSidebar,
  SideBar,
  SidebarMenuItem,
  SidebarProvider,
  truncateMessagesCount,
} from '@vs-online-only-app/ui';
import { useGetActiveConversationsUnreadMessagesCount } from '@vs-online-only-app/state';
import { AppRoutes } from './AppLayout';

const isStandalone = window === window.top;
const messageReceivedAudio = getAppAudio(AudioType.MessageReceived);

const AppSidebar: FC = () => {
  const { data: { totalCount } } =
  useGetActiveConversationsUnreadMessagesCount();

  const visibleUnreadMessagesCount = truncateMessagesCount(
    totalCount,
  );

  useEffect(() => {
    if (!isStandalone) {
      window.top?.postMessage({
        eventName: 'unreadChatMessagesCount',
        count: visibleUnreadMessagesCount,
      }, '*');
    }

    if (!visibleUnreadMessagesCount) return;
    messageReceivedAudio.play();
  }, [visibleUnreadMessagesCount]);

  const items: SidebarMenuItem[] = useMemo(
    () => [
      {
        id: 'home',
        label: 'Home',
        path: AppRoutes.Home,
        Icon: IconStatsSidebar,
      },
      {
        id: 'chat',
        label: 'Chats',
        path: AppRoutes.Chats,
        Icon: IconChatSidebar,
        badgeText: visibleUnreadMessagesCount,
      },
      {
        id: 'settings',
        label: 'Profile settings',
        path: AppRoutes.Settings,
        Icon: IconSettingsSidebar,
      },
    ],
    [visibleUnreadMessagesCount],
  );

  if (!isStandalone) return null;

  return (
    <SidebarProvider
      config={{
        items,
      }}
    >
      <SideBar />
    </SidebarProvider>
  );
};

export default AppSidebar;
